module.exports = __webpack_public_path__ + "static/media/footwear-7.f4643a8d.jpg";